import { Screen } from '../../components';
import { PROTECTED_ROUTES } from '../../constants/routes';
import { Link } from 'react-router-dom';
import { IconFileText, IconSparkles, IconArrowRight } from '@tabler/icons-react';
import clsx from 'clsx';

const StartTestPage = () => {
    return (
        <Screen id="start-test-page" title="Iniciar test">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
                {/* Seleccionar test card */}
                <Link
                    to={`${PROTECTED_ROUTES.TEST}?type=manual`}
                    className={clsx(
                        'group relative overflow-hidden rounded-xl border transition-all duration-300',
                        'bg-white border-gray-200 shadow-md',
                        'dark:bg-surface-dark dark:border-borders dark:shadow-lg',
                        'hover:shadow-xl hover:scale-[1.02]',
                        'hover:border-blue-400 dark:hover:border-blue-500',
                        'no-underline'
                    )}
                >
                    {/* Gradient accent bar */}
                    <div className={clsx(
                        'absolute top-0 left-0 right-0 h-1.5',
                        'bg-gradient-to-r from-blue-500 via-indigo-500 to-purple-500',
                        'dark:from-blue-400 dark:via-indigo-400 dark:to-purple-400'
                    )} />

                    <div className="p-6 md:p-8">
                        {/* Icon */}
                        <div className={clsx(
                            'w-14 h-14 rounded-xl flex items-center justify-center mb-4',
                            'bg-gradient-to-br from-blue-100 to-indigo-100',
                            'dark:from-blue-900/30 dark:to-indigo-900/30',
                            'group-hover:scale-110 transition-transform duration-300'
                        )}>
                            <IconFileText
                                size={28}
                                className="text-blue-600 dark:text-blue-400"
                                strokeWidth={2}
                            />
                        </div>

                        {/* Title */}
                        <h3 className={clsx(
                            'text-xl md:text-2xl font-bold mb-3 transition-colors duration-300',
                            'text-gray-900 dark:text-white'
                        )}>
                            Seleccionar test
                        </h3>

                        {/* Description */}
                        <p className={clsx(
                            'text-sm md:text-base mb-6 leading-relaxed transition-colors duration-300',
                            'text-gray-600 dark:text-surface-light'
                        )}>
                            Selecciona uno de los tests que hemos preparado para ti. Los tienes por bloque, tema, dificultad y generales.
                        </p>

                        {/* Button */}
                        <div className={clsx(
                            'relative inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm',
                            'bg-blue-600 text-white',
                            'dark:bg-blue-500 dark:text-white',
                            'group-hover:bg-blue-700 dark:group-hover:bg-blue-600',
                            'transition-all duration-300',
                            'group-hover:scale-105',
                            'overflow-hidden'
                        )}>
                            {/* Shimmer effect */}
                            <div className={clsx(
                                'absolute inset-0 -translate-x-full group-hover:translate-x-full',
                                'bg-gradient-to-r from-transparent via-white/20 to-transparent',
                                'transition-transform duration-700 ease-in-out'
                            )} />
                            <span className="relative z-10">Empezar test</span>
                            <IconArrowRight
                                size={18}
                                className="relative z-10 group-hover:translate-x-1 transition-transform duration-300"
                            />
                        </div>
                    </div>
                </Link>

                {/* Generar test aleatorio card */}
                <Link
                    to={`${PROTECTED_ROUTES.TEST}?type=random`}
                    className={clsx(
                        'group relative overflow-hidden rounded-xl border transition-all duration-300',
                        'bg-white border-gray-200 shadow-md',
                        'dark:bg-surface-dark dark:border-borders dark:shadow-lg',
                        'hover:shadow-xl hover:scale-[1.02]',
                        'hover:border-purple-400 dark:hover:border-purple-500',
                        'no-underline'
                    )}
                >
                    {/* Gradient accent bar */}
                    <div className={clsx(
                        'absolute top-0 left-0 right-0 h-1.5',
                        'bg-gradient-to-r from-purple-500 via-pink-500 to-rose-500',
                        'dark:from-purple-400 dark:via-pink-400 dark:to-rose-400'
                    )} />

                    <div className="p-6 md:p-8">
                        {/* Icon */}
                        <div className={clsx(
                            'w-14 h-14 rounded-xl flex items-center justify-center mb-4',
                            'bg-gradient-to-br from-purple-100 to-pink-100',
                            'dark:from-purple-900/30 dark:to-pink-900/30',
                            'group-hover:scale-110 transition-transform duration-300'
                        )}>
                            <IconSparkles
                                size={28}
                                className="text-purple-600 dark:text-purple-400"
                                strokeWidth={2}
                            />
                        </div>

                        {/* Title */}
                        <h3 className={clsx(
                            'text-xl md:text-2xl font-bold mb-3 transition-colors duration-300',
                            'text-gray-900 dark:text-white'
                        )}>
                            Generar test aleatorio
                        </h3>

                        {/* Description */}
                        <p className={clsx(
                            'text-sm md:text-base mb-6 leading-relaxed transition-colors duration-300',
                            'text-gray-600 dark:text-surface-light'
                        )}>
                            Genera un test con preguntas aleatorias. Puedes aplicar filtros para acotar el tipo de preguntas que saldrán en el test y así, adaptarlo a lo que necesitas en este momento.
                        </p>

                        {/* Button */}
                        <div className={clsx(
                            'relative inline-flex items-center gap-2 px-5 py-2.5 rounded-lg font-semibold text-sm',
                            'bg-purple-600 text-white',
                            'dark:bg-purple-500 dark:text-white',
                            'group-hover:bg-purple-700 dark:group-hover:bg-purple-600',
                            'transition-all duration-300',
                            'group-hover:scale-105',
                            'overflow-hidden'
                        )}>
                            {/* Shimmer effect */}
                            <div className={clsx(
                                'absolute inset-0 -translate-x-full group-hover:translate-x-full',
                                'bg-gradient-to-r from-transparent via-white/20 to-transparent',
                                'transition-transform duration-700 ease-in-out'
                            )} />
                            <span className="relative z-10">Generar test</span>
                            <IconArrowRight
                                size={18}
                                className="relative z-10 group-hover:translate-x-1 transition-transform duration-300"
                            />
                        </div>
                    </div>
                </Link>
            </div>
        </Screen>
    );
};

export { StartTestPage };
